import { render, staticRenderFns } from "./PopupPrivacyPolicy.vue?vue&type=template&id=3878331f&scoped=true"
import script from "./PopupPrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./PopupPrivacyPolicy.vue?vue&type=script&lang=js"
import style0 from "./PopupPrivacyPolicy.vue?vue&type=style&index=0&id=3878331f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3878331f",
  null
  
)

export default component.exports